import React, { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { RoutePermissionGuard } from '@shared/auth/RoutePermissionGuard';
import { Role } from '@shared/auth/AuthContext';

const LeadsKanbanPage = lazy(() => import('./modules/leads/pages/LeadsKanbanPage').then(m => ({ default: m.LeadsKanbanPage })));
const CounselorsPage = lazy(() => import('./modules/leads/pages/CounselorsPage').then(m => ({ default: m.CounselorsPage })));
const ScholarshipsPage = lazy(() => import('./modules/admissions/pages/ScholarshipsPage').then(m => ({ default: m.ScholarshipsPage })));
const ReferralsPage = lazy(() => import('./modules/admissions/pages/ReferralsPage').then(m => ({ default: m.ReferralsPage })));
const ScoringPage = lazy(() => import('./modules/leads/pages/ScoringPage').then(m => ({ default: m.ScoringPage })));
const CampaignsPage = lazy(() => import('./modules/campaigns/pages/CampaignsPage').then(m => ({ default: m.CampaignsPage })));
const ConsultationRequestsPage = lazy(() => import('./modules/admissions/pages/ConsultationRequestsPage').then(m => ({ default: m.ConsultationRequestsPage })));
const TuitionMatchingPage = lazy(() => import('./modules/admissions/pages/TuitionMatchingPage').then(m => ({ default: m.TuitionMatchingPage })));

const LoadingFallback: React.FC = () => (
  <div className="flex h-64 items-center justify-center">
    <div className="h-6 w-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const CRM_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor'];

export const crmRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="leads" replace />,
  },
  {
    path: 'leads',
    handle: { crumb: 'Leads Pipeline' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <LeadsKanbanPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'scholarships',
    handle: { crumb: 'Scholarship Exam (MMTSE)' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ScholarshipsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'referrals',
    handle: { crumb: 'Referrals & Affiliates' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ReferralsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'counselors',
    handle: { crumb: 'Counselor Pools' },
    element: (
      <RoutePermissionGuard permission="leads.manage" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <CounselorsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'scoring',
    handle: { crumb: 'Lead Scoring Rules' },
    element: (
      <RoutePermissionGuard permission="leads.manage" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ScoringPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'campaigns',
    handle: { crumb: 'Campaigns & Sources' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <CampaignsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'consultations',
    handle: { crumb: 'Study Consultations' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ConsultationRequestsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'tuition-requests',
    handle: { crumb: 'Tuition Demands & Bidding' },
    element: (
      <RoutePermissionGuard permission="crm.read" allowedRoles={CRM_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <TuitionMatchingPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
];
